export default class Size {
	constructor(
		public height: number,
		public width: number
	) { }
}


// WEBPACK FOOTER //
// ./src/utils/Size.ts